import React from 'react';

import { Text } from '@mantine/core';

type DisplayTimeProps = {
  value: string;
};

function DisplayTime({ value }: DisplayTimeProps): JSX.Element {
  return (
    <Text align='center' sx={{ fontSize: 48, lineHeight: 1, fontWeight: 600 }} my={20}>
      {value}
    </Text>
  );
}

export default DisplayTime;
